import React, { PureComponent } from 'react';
import Icon from 'style/fonts/glyphmaps/icon.component';

class OpacityModal extends PureComponent {
  _interval = null;
  state = {
    opacity: 0,
  };

  _show = () => {
    const { opacity } = this.state;
    let newOpacity = opacity;
    clearInterval(this._interval);

    this._interval = setInterval(() => {
      newOpacity += 0.05;
      if (newOpacity >= 1) clearInterval(this._interval);
      this.setState({ opacity: newOpacity });
    }, 20);
  };

  _hide = () => {
    const { opacity } = this.state;
    clearInterval(this._interval);
    let newOpacity = opacity;

    this._interval = setInterval(() => {
      newOpacity -= 0.05;
      if (newOpacity <= 0) clearInterval(this._interval);
      this.setState({ opacity: newOpacity });
    }, 20);
  };

  componentDidMount() {
    const { modalRef } = this.props;
    modalRef && modalRef(this);
  }

  render() {
    const { opacity } = this.state;
    const { title, containerStyle } = this.props;

    if (opacity > 0)
      return (
        <div
          className="opacity-modal max-fixed flex-row align-center justify-center"
          style={{ opacity }}
        >
          <div
            className="relative flex-column"
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: 5,
              padding: 20,
              maxWidth: '90%',
              ...containerStyle,
            }}
          >
            {title && (
              <span className="opacity-modal-title  self-align-center">
                {title}
              </span>
            )}
            <Icon
              fontFamily="AntDesign"
              name="close"
              size={23}
              onClick={this._hide}
              style={{ top: 5, right: 0 }}
              className="absolute close"
            />
            {this.props.children}
          </div>
        </div>
      );

    return null;
  }
}

export default OpacityModal;
